module.exports = __webpack_public_path__ + "static/media/fresh-hazel.a56c28f4.png";